import SyTooltip from "./sy-tooltip";

export default SyTooltip;